import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
import { DropdownContent } from "@/patterns/global-nav/src/dropdown-content.tsx";
import { CompoundSubNavProps } from "@/patterns/global-nav/src/nav-global-compound-subnav";
import { useIsMobile } from "@/utils/useIsMobile.ts";

export const CollectionsCompoundSubNavProps = () => {
    const intl = useIntl();

    const teamworkOverviewHref = useLocalizedHref("/collections/teamwork");
    const teamworkFeaturesHref = useLocalizedHref(
        "/collections/teamwork/features"
    );
    const teamworkEnterpriseHref = useLocalizedHref(
        "/collections/teamwork/enterprise"
    );
    const teamworkPricingHref = useLocalizedHref(
        "/collections/teamwork/pricing"
    );
    const teamworkResourcesHref = useLocalizedHref(
        "/collections/teamwork/resources"
    );

    const strategyOverviewHref = useLocalizedHref("/collections/strategy");
    const strategyDemoCenterHref = useLocalizedHref(
        "/collections/strategy/demo-center"
    );
    const strategyPricingHref = useLocalizedHref(
        "/collections/strategy/pricing"
    );

    const serviceOverviewHref = useLocalizedHref("/collections/service");
    const servicePricingHref = useLocalizedHref("/collections/service/pricing");

    const softwareHref = useLocalizedHref("/collections/software");

    const collectionsHref = useLocalizedHref("/collections");

    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = useIsMobile(1024);

    const hasSubnav = !isMobile;

    const props: CompoundSubNavProps = {
        optionalClassName: "collections-nav",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav,
                content: (
                    <DropdownContent
                        orientation="column"
                        contentSections={[
                            {
                                links: [
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.overview",
                                            defaultMessage: "Overview"
                                        }),
                                        href: teamworkOverviewHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.features",
                                            defaultMessage: "Features"
                                        }),
                                        href: teamworkFeaturesHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.enterprise",
                                            defaultMessage: "Enterprise"
                                        }),
                                        href: teamworkEnterpriseHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.pricing",
                                            defaultMessage: "Pricing"
                                        }),
                                        href: teamworkPricingHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.resources",
                                            defaultMessage: "Resources"
                                        }),
                                        href: teamworkResourcesHref
                                    }
                                ]
                            }
                        ]}
                    />
                )
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav,
                content: (
                    <DropdownContent
                        orientation="column"
                        contentSections={[
                            {
                                links: [
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.overview",
                                            defaultMessage: "Overview"
                                        }),
                                        href: strategyOverviewHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.demoCenter",
                                            defaultMessage: "Demo Center"
                                        }),
                                        href: strategyDemoCenterHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.pricing",
                                            defaultMessage: "Pricing"
                                        }),
                                        href: strategyPricingHref
                                    }
                                ]
                            }
                        ]}
                    />
                )
            },
            {
                globalLinksKey: "service",
                linkText: "Service",
                href: serviceOverviewHref,
                hasSubnav,
                content: (
                    <DropdownContent
                        orientation="column"
                        contentSections={[
                            {
                                links: [
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.overview",
                                            defaultMessage: "Overview"
                                        }),
                                        href: serviceOverviewHref
                                    },
                                    {
                                        text: intl.formatMessage({
                                            id: "CollectionsCompoundSubNavProps.pricing",
                                            defaultMessage: "Pricing"
                                        }),
                                        href: servicePricingHref
                                    }
                                ]
                            }
                        ]}
                    />
                )
            },
            {
                globalLinksKey: "software",
                linkText: "Software",
                hasSubnav: false,
                href: softwareHref
            }
        ],
        isShowCta: false,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };

    return props;
};
